import React, { useEffect, useState } from 'react';

import { Grid, Dialog, Typography } from '@material-ui/core';
import ButtonProgress from '../../commons/ButtonProgress';

import { useStyles } from './use3dsecure.styles';

function ProgressDialog (props) {
    const {
        open,
        url = '',
    } = props;

    const [isValidating, setIsValidating] = useState(false);
    const classes = useStyles();
    
    useEffect(() => {
        console.log('mounting progress dialog...', open);
    }, []);

    return (<Dialog
        open={open}
    >
         <Grid className={classes.topPanel}>
                <Typography
                    variant={'h5'}
                    weight={500}
                    style={{ marginLeft: '12px', }}
                >
                    Verification Required
                </Typography>
        </Grid>

        <Grid
            container
            className={classes.dialogContent}>
             
            <Typography
                variant="body"
                className={classes.message}
            >
                Your card requires 3D secure authentication.<br/>
                If your bank authentication pop-up did not show,<br/> please turn off the pop-up blocker and repeat the process.
            </Typography>
              <ButtonProgress
                    disabled={false}
                    showProgress={isValidating}
                    label="Authenticate 3DS"
                    onClick={(e) => {
                        window.open(url, '_blank');
                        setIsValidating(true);
                    }}
                />
        </Grid>
    </Dialog>);
}

export default ProgressDialog;
